import { IcurrentLanguage, IRootState } from '../types/IRootState';

const languageGetters = {
    getAllLanguages: (state: IRootState): IcurrentLanguage[] => {
        return state.activeLanguages;
    },
    getActiveLanguages: (state: IRootState): IcurrentLanguage[] => {
        return state.activeLanguages.filter((language: IcurrentLanguage) => language.value === true);
    },
    getLanguage: (state: any) => (languageName: string): IcurrentLanguage => {
        return state.activeLanguages
            .find((language: IcurrentLanguage) => language.name === languageName);
    },
    getGlobalLanguage: (state: IRootState): string => {
        return state.globalLanguage;
    },
};
export default languageGetters;
